import { isValueStringBetween } from './isValue.ts';
export class ValidationError extends Error {
    constructor(message, value){
        super(message);
        this.value = value;
    }
}
export function checkValueIsStringBetween(value, minLength, maxLength, errorMessage = 'Value is not a valid string') {
    if (!isValueStringBetween(value, minLength, maxLength)) {
        throw new ValidationError(errorMessage, value);
    }
    return value;
}
const validServerIdRE = /^[a-z\d]{4,20}$/i;
export function checkValueIsServerId(value, errorMessage = 'Value is not a valid server id') {
    if (!validServerIdRE.test(value)) {
        throw new ValidationError(errorMessage, value);
    }
    return value;
}
const validMQTopicPartRE = /^[a-z]{2,20}$/i;
export function checkValueIsMQTopicPart(value, errorMessage = 'Value is not a valid MQ topic part') {
    if (!validMQTopicPartRE.test(value)) {
        throw new ValidationError(errorMessage, value);
    }
    return value;
}
